export default __webpack_public_path__ + "static/media/ga.d33bfe61.svg";